import BackButton from '@/components/back-button/back-button';
import ContentContainerAuthPages from '@/components/layout-auth/components/content-container-auth-pages/content-container-auth-pages';
import FooterAuth from '@/components/layout-auth/components/footer-auth/footer-auth';
import FormContainerAuthPages from '@/components/layout-auth/components/form-container-auth-pages/form-container-auth-pages';
import ImageSectionAuthPages from '@/components/layout-auth/components/image-section-auth-pages/image-section-auth-pages';
import MainContentAuth from '@/components/layout-auth/components/main-content-auth/main-content-auth';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import Troubleshoot from '@/components/troubleshoot/Troubleshoot';
import VerifyEmailBody from '@/components/verify-email/verify-email-body';
import VerifyEmailFooter from '@/components/verify-email/verify-email-footer';
import VerifyEmailHeader from '@/components/verify-email/verify-email-header';
import { Box, Grid } from '@cmpsr/components';
import image1000 from '../images/sign-in-1000w.avif';
import image1200 from '../images/sign-in-1200w.avif';
import image1600 from '../images/sign-in-1600w.avif';
import image2000 from '../images/sign-in-2000w.avif';
import image400 from '../images/sign-in-400w.avif';
import image600 from '../images/sign-in-600w.avif';
import image800 from '../images/sign-in-800w.avif';
import imageJpg from '../images/sign-in.jpg';
import useVerifyOTPController from './verify-otp.controller';

export default function VerifyOTPPage() {
  const { email, form, handleSubmit, handleResendCode, countdown, showResend, handleBack } = useVerifyOTPController();

  return (
    <Box>
      <NavigationBar leftContent={<BackButton onClick={handleBack} />} beta />
      <MainContentAuth>
        <ImageSectionAuthPages
          srcset={`${image400} 400w, ${image600} 600w, ${image800} 800w, ${image1000} 1000w, ${image1200} 1200w, ${image1600} 1600w, ${image2000} 2000w`}
          sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
          src={imageJpg}
          alt="Verify your email"
          display={{ base: 'none', lg: 'block' }}
        />
        <ContentContainerAuthPages
          position={{ base: 'initial', lg: 'relative' }}
          background="url(/images/footer-auth_3840px.svg)"
          backgroundRepeat="no-repeat"
          backgroundPosition={{
            base: 'center calc(100% - 86px)',
            lg: 'center calc(100% - 56px)',
            xxl: 'center calc(100% - 86px)',
          }}
          backgroundSize="auto 200px"
        >
          <Grid
            // In short screen sizes the content will have scroll
            // In higher screen sizes the content will be centered and the footer will be at the bottom
            gridTemplateRows="minmax(min-content, 1fr) min-content"
            alignItems="center"
            minHeight="full"
            overflow="auto"
          >
            <Box
              as="form"
              width={{ base: '100%', lg: '464px', xl: '529px' }}
              onSubmit={handleSubmit}
              px={{ base: 5, md: 8, lg: 0 }}
              pt={{ base: 5, lg: 0 }}
              mx="auto"
            >
              <FormContainerAuthPages>
                <VerifyEmailHeader variant="text-header-4XL" textStyle="text-header-4xl-v" email={email} />
                <VerifyEmailBody
                  isFormControlInvalid={!!form.formState.errors.otp?.message}
                  pinInputProps={{
                    isInvalid: !!form.formState.errors.otp?.message,
                    onChange: (val) => {
                      form.clearErrors('otp');
                      form.setValue('otp', val, { shouldValidate: val.length === 6 });
                    },
                    isDisabled: form.formState.isSubmitting,
                  }}
                  formErrorMessage={form.formState.errors.otp?.message}
                  size={{
                    base: 'm',
                    md: 'l',
                  }}
                />

                <VerifyEmailFooter
                  onClick={handleResendCode}
                  buttonProps={{
                    isDisabled: !form.formState.isValid,
                    isLoading: form.formState.isSubmitting,
                  }}
                  textButton="Verify"
                  showResend={showResend}
                  countdown={countdown}
                />
              </FormContainerAuthPages>
              <Troubleshoot troubleshootIssue="Trouble signing in?" linkDisplay={{ base: 'block', md: 'inline' }} />
            </Box>
            <FooterAuth />
          </Grid>
        </ContentContainerAuthPages>
      </MainContentAuth>
    </Box>
  );
}
